import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { dashboardService } from '../api/dashboard.service';
import { DASHBOARD_KEYS } from './queryKeys';
import type { WidgetDataDto, WidgetScope } from '../types';

export function useWidgetData(widgetId: string, scope: WidgetScope) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const scopeId =
    scope.type === 'project'
      ? (scope.projectId ?? '')
      : scope.type === 'board'
        ? (scope.boardId ?? '')
        : scope.tenantId;

  return useQuery({
    queryKey: DASHBOARD_KEYS.widgetData(orgId ?? '', scope.type, scopeId, widgetId),
    queryFn: ({ signal }) => dashboardService.getWidgetData(scope.type, scopeId, widgetId, signal),
    select: (r): WidgetDataDto => r.data,
    staleTime: 120_000,
    enabled: !!orgId && !!scopeId && !!widgetId,
  });
}
